export default __webpack_public_path__ + "static/media/IMG_4003.bca42cdd.PNG";